import styled from 'styled-components';
import { FC } from 'react';
import { Collapse } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { CollapseProps } from './types';

export const StyledCollapse = styled<FC<CollapseProps>>(Collapse)`
  border-color: #bdc5db;
  border-radius: 8px;
  background: #f7f9fe;
  font-family: 'Museo Sans Cyrl', sans-serif;

  &.ant-collapse-borderless > .ant-collapse-item {
    border: none;
  }

  .ant-collapse-item {
    border-color: #bdc5db;
  }

  .ant-collapse-content {
    border-color: #bdc5db;
  }

  &.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
    border: none;
    background: ${colors.gray0};
  }

  .ant-collapse-item .ant-collapse-header {
    align-items: center;
  }

  & > .ant-collapse-item:last-child,
  .ant-collapse-item:last-child > .ant-collapse-content {
    border-radius: 0 0 8px 8px;
  }

  .ant-collapse-extra {
    .anticon {
      font-size: 16px;
      vertical-align: -4px;
    }

    .ant-btn {
      padding: 0;
    }
  }

  .ant-collapse-extra,
  .ant-collapse-content > .ant-collapse-content-box {
    color: ${colors.gray900};
    font-family: inherit;
  }

  & > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 24px;
  }
`;
